const safeJsonParse = (value, fallback) => {
  if (!value) return fallback;
  if (Array.isArray(value)) return value;
  try {
    const parsed = typeof value === "string" ? JSON.parse(value) : value;
    return Array.isArray(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
};

const stripMarkdown = (value = "") => value
  .replace(/[#*_>`\-[\]()]/g, " ")
  .replace(/\s+/g, " ")
  .trim();

export function adaptLearningArticle(article) {
  const sections = safeJsonParse(article.sections, []).map((section) => ({
    heading: section.heading || section.title || "Article section",
    body: section.body || section.summary || section.description || "",
  })).filter((section) => section.body);

  const faq = safeJsonParse(article.faq, []).map((item) => ({
    q: item.q || item.question || "Question",
    a: item.a || item.answer || "",
  })).filter((item) => item.a);

  const content = [article.content, article.content_part_2, article.content_part_3, article.content_part_4].filter(Boolean).join("\n\n");
  const contentText = stripMarkdown(content);
  const excerpt = article.meta_description || contentText.slice(0, 180) || "Open this learning article for practical sailing guidance.";

  return {
    ...article,
    content,
    excerpt,
    keyPoints: article.keywords?.slice(0, 4) || [article.difficulty_level || "Learning", `${article.reading_time_minutes || 5} min read`, article.subtopic || "Sailing guide"],
    sections: sections.length ? sections : [{ heading: "Article overview", body: contentText.slice(0, 420) || excerpt }],
    faq,
  };
}

export function adaptLearningArticles(articles = []) {
  return articles.map(adaptLearningArticle);
}